// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"8c4426d5","404":"33d7e4ba","498":"eee8c013"}[chunkId] + ".chunk.js";
};